import { Theme } from '@material-ui/core'

const profileStyles = ({ breakpoints }: Theme) => ({
  root: {
    backgroundColor: '#fafafa',
    width: '100%',
    minHeight: '100vh'
  },
  container: {
    width: '100%'
  },
  logoutButton: {
    marginTop: '1rem'
  },
  imageContainer: {
    width: '100%',
    height: '50%',
    alignItems: 'flex-start',
    justifyContent: 'center',
    [breakpoints.down('sm')]: {
      display: 'none'
    },
    [breakpoints.up('md')]: {
      display: 'inline-flex'
    },
    [breakpoints.up('lg')]: {}
  },
  image: {
    width: 'fit-content'
  },
  formPaper: {
    marginTop: '2rem',
    display: 'flex',
    flexDirection: 'column' as const,
    minWidth: '85%',
    boxSizing: 'border-box' as const,
    padding: '35px 50px 35px 50px',
    [breakpoints.down('md')]: {
      padding: '35px 25px 45px 25px'
    },
    [breakpoints.down('sm')]: {
      padding: '24px',
      marginTop: '1rem',
      minWidth: '100%',
      width: '100%'
    }
  },
  form: {
    display: 'flex',
    maxWidth: '650px',
    maxHeight: '700px',
    [breakpoints.down('sm')]: {
      width: '95vw',
      marginBottom: '2rem',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    [breakpoints.up('xl')]: {
      display: 'flex',
      maxWidth: '1000px'
    }
  },
  largeForm: {
    padding: '35px 50px 35px 50px',
    display: 'flex',
    maxWidth: '950px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [breakpoints.down('sm')]: {
      padding: '0px 5px'
    },
    [breakpoints.up('lg')]: {
      display: 'flex',
      maxWidth: '950px'
    }
  },
  greetings: {
    textAlign: 'start' as const,
    marginTop: '2rem',
    marginLeft: '2rem',
    [breakpoints.down('xs')]: {
      marginLeft: '0',
      padding: '0 1rem',
      textAlign: 'center' as const
    }
  },
  loggedInStatus: {
    textAlign: 'start' as const,
    marginBottom: '2rem',
    marginLeft: '2rem',
    [breakpoints.down('xs')]: {
      marginLeft: '0',
      marginBottom: '1.25rem',
      padding: '0 1rem',
      textAlign: 'center' as const
    }
  },
  changePassTitle: {
    textAlign: 'start' as const,
    marginTop: '2rem'
  },
  editTitle: {
    textAlign: 'start' as const
  }
})

export { profileStyles }
